<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2026, Dr. Ing. h.c. F. Porsche AG.
  -->
@if (!addresses().length && emptyListLabel) {
  <profile-pds-p-text p-text color="contrast-medium">
    {{ emptyListLabel }}
  </profile-pds-p-text>
}

@if (addresses().length) {
  <div>
    @if ((shouldShowEditor$ | async) === false) {
      <ul
        role="list"
        class="profile:inline-flex profile:flex-col profile:md:flex-row profile:flex-wrap profile:w-full"
        [attr.aria-label]="listAriaLabel"
      >
        @for (item of addresses(); track item.addressId) {
          <li
            class="profile:relative profile:mb-static-md profile:min-w-60 profile:max-xs:min-w-[320px] profile:max-sm:not-last:me-static-lg profile:max-sm:mt-0 profile:max-xs:first:mt-0 profile:leading-6"
          >
            <div data-protractor-id="address-widget-list-formatted-address-content" class="fs-exclude">
              <div class="profile:flex profile:items-center profile:mt-fluid-md profile:md:mt-0 profile:w-full">
                @if (item.isStandard) {
                  <span class="profile:sr-only">{{ 'pidpaw.selectAddress.address.preferredMarker' | translate }}, </span>
                }
                @if (item.usage === 'work') {
                  <profile-pds-p-icon p-icon name="work" color="contrast-medium" size="xx-small" aria-hidden="true"></profile-pds-p-icon>
                }
                @if (item.usage === 'home') {
                  <profile-pds-p-icon p-icon name="home" size="xx-small" aria-hidden="true"></profile-pds-p-icon>
                }
                <profile-pds-p-text
                  class="profile:text-[14px] profile:ml-1 profile:inline-block"
                  p-text
                  size="inherit"
                  color="contrast-medium"
                  >{{ translatedAddressType[item.usage ?? 'home'] }}</profile-pds-p-text
                >
              </div>
              <profile-pds-p-text p-text size="inherit" class="profile:text-[20px]">
                <span [innerHTML]="item.formattedAddress | pidxEscapeHtml | pidxNewLineTransform"></span>
              </profile-pds-p-text>
            </div>
            @if ((itemIdBeingEdited$ | async) !== item.addressId) {
              <div class="profile:flex profile:flex-row profile:gap-x-static-md">
                <div>
                  <profile-pds-p-button-pure
                    p-button-pure
                    icon="edit"
                    class="profile:py-fluid-sm"
                    [attr.id]="'edit-btn-' + item.addressId"
                    [aria]="{ 'aria-label': editButtonAriaLabel(item) }"
                    (click)="editItem(item)"
                    [myprofileUiTrack]="{
                      clickElementType: 'button',
                      clickElementId: 'address',
                      clickElementName: 'edit',
                    }"
                  >
                    {{ editItemLabel }}
                  </profile-pds-p-button-pure>
                </div>
                <div>
                  <profile-pds-p-button-pure
                    p-button-pure
                    class="profile:py-fluid-sm"
                    icon="delete"
                    [attr.id]="'delete-btn-' + item.addressId"
                    [aria]="{ 'aria-label': deleteButtonAriaLabel(item), 'aria-haspopup': 'dialog' }"
                    (click)="deleteItem(item)"
                    [myprofileUiTrack]="{
                      clickElementType: 'button',
                      clickElementId: 'address',
                      clickElementName: 'delete',
                    }"
                  >
                    {{ deleteItemLabel }}
                  </profile-pds-p-button-pure>
                </div>
              </div>
            }
          </li>
        }
      </ul>
    }
    @if (shouldShowEditor$ | async) {
      <div>
        <myprofile-address-editform
          [instanceId]="instanceId"
          [token]="token"
          [cancelButtonLabel]="'pidpaw.editAddress.button.cancel.label' | translate"
          [saveButtonLabel]="'pidpaw.editAddress.button.save.label' | translate"
        ></myprofile-address-editform>
      </div>
    }
  </div>
}

@if (listHasLoadingOverlay$ | async) {
  <pidx-loader [mode]="PidxLoaderModeEnum.OVERLAY" [loadingLabel]="'addressWidget.general.savingStatus' | translate"></pidx-loader>
}
